import { render, staticRenderFns } from "./AudioFileSelect.vue?vue&type=template&id=552cfafb&scoped=true"
import script from "./AudioFileSelect.vue?vue&type=script&lang=js"
export * from "./AudioFileSelect.vue?vue&type=script&lang=js"
import style0 from "./AudioFileSelect.vue?vue&type=style&index=0&id=552cfafb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552cfafb",
  null
  
)

export default component.exports